import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件

export default {
  name: 'HandleAlarmEventModal',
  data () {
    return {
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    alarmEvent: {
      type: Object,
      default: {}
    }
  },
  mixins: [
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  mounted () {
  },
  methods: {
    //
    handlePrintTrue() {
      this.$refs.handleIdeaTextArea.value = '真实告警'
    },
    //
    handlePrintFalse() {
      this.$refs.handleIdeaTextArea.value = '误报'
    },
    //
    handleClearHandleIdea() {
      this.$refs.handleIdeaTextArea.value = ''
    },
    // 提交记录
    handleModalSubmit () {
      this.$confirm('您确定提交告警处理结果吗?', '询问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http(this.$api.confirmAlarm, {
          eventId: this.alarmEvent.id,
          handleIdea: this.$refs.handleIdeaTextArea.value
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            })
            this.$emit('submit', false)
          } else {
            this.$message({
              type: 'error',
              message: '提交失败!'
            })
          }
        })
      })
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/handleAlarmEventModal/HandleAlarmEventModal.js